<template>
    <el-dialog title="更改订单状态" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" width="50%">
        <el-form size="small" :model="form" ref="form">

            <el-form-item label="订单状态：" :label-width="formLabelWidth" prop="waiterState">
                <el-radio-group v-model="form1.waiterState">
                    <el-radio :label="0">待接单</el-radio>
                    <el-radio :label="1">待出发</el-radio>
                    <el-radio :label="2">待到达</el-radio>
                    <el-radio :label="3">待服务</el-radio>
                    <el-radio :label="4">服务中</el-radio>
                    <el-radio :label="5">已完成</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submit" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OrderApi from "@/api/order.js";
export default {
    data() {
        return {
            /*左边长度*/
            formLabelWidth: "130px",
            /*是否显示*/
            dialogVisible: false,
            /*是否正在提交*/
            submit_loading: false,
            isproduct: false,
            type: 10,
            num: 20,
            tableData: [],
            product_arr: [],
            form1: {
                waiterState: "",
                orderId: ""
            }
        };
    },
    props: ["open_orderStatus", "form"],
    created() {
        // yong
        this.form1.orderId = this.form.orderId;
        this.form1.waiterState = this.form.waiterState;
        this.dialogVisible = this.open_orderStatus;
        // console.log('==========this.form=', this.form)
        // 
    },
    methods: {
        submit() {
            let self = this;
            let params = this.form1;
            self.$refs.form.validate(valid => {
                if (valid) {
                    self.submit_loading = true;
                    OrderApi.orderStatus(params, true)
                        .then(data => {
                            self.submit_loading = false;
                            self.$message({
                                message: "恭喜你，修改成功",
                                type: "success"
                            });
                            self.dialogFormVisible(true);
                        })
                        .catch(error => {
                            self.submit_loading = false;
                        });
                }
            });
        },
        /*关闭弹窗*/
        dialogFormVisible(e) {
            if (e) {
                this.$emit("closeDialog", {
                    type: "success",
                    openDialog: false
                });
            } else {
                this.$emit("closeDialog", {
                    type: "error",
                    openDialog: false
                });
            }
        }
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/order-status.vue